import type { FaireProductEntity } from "../../entity_types/product";

export const p_a5ijeyr7fg: FaireProductEntity = {
  token: "p_a5ijeyr7fg",
  type: "product",
  name: "Stacking Rings (Set of 3)",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/9f695cd4abdd8065e13d154cd9bb389f565b0cbea05b733b14b89aed45b29f21.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ea0aa2a065e7ecd61440eeca0e4aa45cf412e959d71dad96312daecabc8594f.jpeg"
  ],
  priceDollars: 7.5,
  description: "Thin, brass hammered rings. Wear as separates or stack 'em up! Sold in sets of 3.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:15.797Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
